import * as React from 'react';

const SvgChevronLeftFill = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "m9.832 12 5.61-5.582L14.033 5 7 12l7 7 1.414-1.415L9.832 12Z", fill: "currentColor" })));

export { SvgChevronLeftFill as default };
